module.exports = __webpack_public_path__ + "img/logo_invert.43a093bb.png";